
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    
import useTranslation from "next-translate/useTranslation";

export default function CookiesPolicyPage() {
  const { t } = useTranslation("cookies-policy");
  const cookiesPolicy = t("cookies-policy", {}, { returnObjects: true });

  return (
    <article id="cookies-policy">
      <div className="d-flex col ai-c jc-c gp-64">
        <h3>{cookiesPolicy.title}</h3>
        <div className="d-flex col ai-c jc-c gp-32">
          {cookiesPolicy.policy.map((text, id) => {
            return <span key={id}>{text}</span>;
          })}
        </div>
      </div>
    </article>
  );
}


    export async function getStaticProps(ctx) {
        
        
        return {
          
          
          props: {
            
            ...(await __loadNamespaces({
              ...ctx,
              pathname: '/cookies-policy/index',
              loaderName: 'getStaticProps',
              ...__i18nConfig,
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
            }))
          }
        }
    }
  